import { render } from "./GestionCreditos.vue?vue&type=template&id=53a4a100&scoped=true"
import script from "./GestionCreditos.vue?vue&type=script&lang=js"
export * from "./GestionCreditos.vue?vue&type=script&lang=js"

import "./GestionCreditos.vue?vue&type=style&index=0&id=53a4a100&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53a4a100"]])

export default __exports__